// Module
var code = "<dialog-template class=\"alert-dialog\"> <template v-slot:header>{{ inputData.title }}</template> <template v-slot:content>{{ inputData.message }}</template> <template v-slot:footer> <button type=\"button\" @click=\"closeDialog()\">{{ $t('dialog.alert.okButton') }}</button> </template> </dialog-template>";
// Exports
module.exports = code;